import React, { useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';
import Header from './Header';
import Alarm from './Alarm';
import Modal from './Modal';
import Footer from './Footer';
import Overlay from './Overlay';
import { useOverlay } from '../context/OverlayContext';
import useResponsive from './../hooks/useResponsive';
import useAuth from '../context/AuthContext';
import Sidebar from './SideBar';
import HeaderBar from './HeaderBar';

export default function Root() {
  const ref = useRef();
  const { isTablet } = useResponsive();
  const { pathname } = useLocation();
  const { overlay } = useOverlay();

  return (
    <>
      <div
        ref={ref}
        style={{ height: '100dvh' }}
        className="relative flex flex-col"
      >
        <Alarm />
        <Modal />
        <div className="flex flex-row w-full " style={{height: '100dvh'}}>
          <Sidebar />
          <div className="flex-grow min-w-0 overflow-auto">
            {/* <Header /> */}
            <HeaderBar />
            <Outlet />
            {!pathname.includes('program') &&
              !pathname.includes('help-to-habit') &&
              !pathname.includes('admin') &&
              !pathname.includes('users') &&
              !pathname.includes('phone-verification') &&
              !pathname.includes('chat') && <Footer />}
            {pathname.startsWith('/v2/users/access') && <Footer />}
          </div>
        </div>
        {overlay && !isTablet && (
          <Overlay className={`${overlay ? 'show' : 'hide'}`} />
        )}
      </div>
    </>
  );
}
